module.exports = __webpack_public_path__ + "img/17865_S.20a82cfc.png";